import TimelineIcon from "@mui/icons-material/Timeline";
import ViewListIcon from "@mui/icons-material/ViewList";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import type { FC } from "react";

export type TimelineLayout = "timeline" | "list";

/**
 * Pills to show the Communications on a timeline or in a list, as in the design: smaller than the
 * dashboard's FeedToggle, with icons, and a shadow on the one picked in place of a border.
 */
export const LayoutToggle: FC<{
  value: TimelineLayout;
  onChange: (layout: TimelineLayout) => void;
}> = ({ value, onChange }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    value={value}
    // Clicking the one already picked would pick none.
    onChange={(_, layout: TimelineLayout | null) => layout && onChange(layout)}
    aria-label="View"
    sx={{
      p: 0.25,
      borderRadius: "18px",
      bgcolor: "action.selected",
      "& .MuiToggleButton-root": {
        height: 32,
        px: 1.5,
        m: 0,
        border: 0,
        borderRadius: "16px",
        textTransform: "none",
        fontSize: 13,
        fontWeight: 600,
        color: "text.secondary",
      },
      "& .MuiToggleButton-root.Mui-selected, & .MuiToggleButton-root.Mui-selected:hover": {
        bgcolor: "background.paper",
        color: "primary.main",
        boxShadow: "0 1px 2px rgba(100, 116, 139, 0.2)",
      },
    }}
  >
    <ToggleButton value="timeline" data-analytics-id="program-timeline-layout-timeline">
      <TimelineIcon sx={{ fontSize: 18, mr: 0.75 }} />
      Timeline
    </ToggleButton>
    <ToggleButton value="list" data-analytics-id="program-timeline-layout-list">
      <ViewListIcon sx={{ fontSize: 18, mr: 0.75 }} />
      List
    </ToggleButton>
  </ToggleButtonGroup>
);
